import { render, staticRenderFns } from "./ContactSelectionBubble.vue?vue&type=template&id=348d5b73&scoped=true"
import script from "./ContactSelectionBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactSelectionBubble.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348d5b73",
  null
  
)

export default component.exports